import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useSnackbarActionCloseButtonStyles } from 'components/Shared/Buttons/styles';

export const SnackbarActionCloseButton = ({ snackbarKey }) => {
  const { classes } = useSnackbarActionCloseButtonStyles();
  const { closeSnackbar } = useSnackbar();

  const handleCloseClick = () => closeSnackbar(snackbarKey);

  return (
    <Box className={classes.root} onClick={handleCloseClick}>
      <CloseIcon className={classes.icon} />
    </Box>
  );
};
